import * as React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShieldCheck } from '@fortawesome/pro-duotone-svg-icons/faShieldCheck'
import { Container } from '../Container'

type Props = {
  title: string
  description: string | React.ReactElement
}

export const HappinessGuaranteeSection: React.FC<Props> = ({ description, title }) => (
  <section className="xl:py-20 text-center" style={{ backgroundColor: 'white' }}>
    <Container>
      <FontAwesomeIcon icon={faShieldCheck} color={`#f04f23`} size={'7x'} />
      <h2 className="py-4 title text-2xl sm:text-3xl md:text-4xl">{title}</h2>
      <p className="description">{description}</p>
    </Container>
  </section>
)
